import { FieldErrors } from './field-errors';

export interface RequestState {
  inProgress?: boolean;
  success?: boolean;
  error?: boolean;
  fieldErrors?: FieldErrors;
  status?: number;
}

export const RETRY_COUNT = 3;
export const TIMEOUT = 30 * 1000;
export const SHORT_TIMEOUT = 15 * 1000;
export const MAX_SIZE = 5 * 1024 * 1024;
